import sapDepartments from 'utils/constants/sapDepartment.json'
import departments from 'utils/constants/department.json'
import sapSections from 'utils/constants/sapSection.json'
import sections from 'utils/constants/section.json'
import sapFamily from 'utils/constants/sapFamily.json'
import family from 'utils/constants/family.json'

export const noneField = {
  label: '--- NONE ---',
  value: 'NONE',
  disabled: false,
}

/**
 * Get Family by family code (we will first check value in sapFamily.json, if not found then check in family.json)
 */
const getFamily = (familyCode: string) => {
  const sapFamilyValue = sapFamily.find((fm) => fm.familyCode === familyCode)
    ?.family
  if (!sapFamilyValue) {
    const familyValue = family.find((fm) => fm.familyCode === familyCode)
      ?.family
    return familyValue ?? familyCode
  }
  return sapFamilyValue
}

/*  *
 * Get Section by Section code (we will first check value in sapSection.json, if not found then check in section.json)
 */
const getSection = (sectionCode: string) => {
  const sapSectionValue = sapSections.find(
    (section) => section.sectionCode === sectionCode,
  )?.section
  if (!sapSectionValue) {
    const sectionValue = sections.find(
      (section) => section.sectionCode === sectionCode,
    )?.section
    return sectionValue ?? sectionCode
  }
  return sapSectionValue
}

/**
 * Get Department by Department code (we will first check value in sapDepartment.json, if not found then check in department.json)
 */
const getDepartment = (deptCode: string) => {
  const sapDepartmentValue = sapDepartments.find(
    (dept) => dept.departmentCode === deptCode,
  )?.department
  if (!sapDepartmentValue) {
    const departmentValue = departments.find(
      (dept) => dept.departmentCode === deptCode,
    )?.department
    return departmentValue ?? deptCode
  }
  return sapDepartmentValue
}

/**
 * The option helpers below back both hierarchies: pass `isSap` to read from the
 * SAP lookup tables, otherwise they read from the legacy ones.
 */
const getDepartmentOptions = (isSap = false) => {
  const options = (isSap ? sapDepartments : departments).map((dept) => ({
    value: dept.departmentCode,
    label: dept.department,
    disabled: false,
  }))

  options.unshift(noneField)
  return options
}

const getSectionOptionsByDepartment = (dept: string, isSap = false) => {
  if (dept === 'NONE') {
    return [noneField]
  }

  const options = (isSap ? sapSections : sections)
    .filter((section) => dept === section.departmentCode)
    .map((section) => ({
      value: section.sectionCode,
      label: section.section,
      disabled: false,
    }))

  options.unshift(noneField)

  return options
}

const getFamiliesOptionsBySection = (section: string, isSap = false) => {
  if (!section || section === 'NONE') {
    return [noneField]
  }

  const options = (isSap ? sapFamily : family)
    .filter((fm) => fm.sectionCode === section)
    .map((fm) => ({
      value: fm.familyCode,
      label: fm.family,
      disabled: false,
    }))

  options.unshift(noneField)

  return options
}

/**
 * Split a slash-separated category path ("A/B/C") into trimmed, non-empty
 * levels — used to render the Main Category breadcrumb.
 */
const splitCategoryPath = (path?: string): string[] =>
  (path || '')
    .split('/')
    .map((level) => level.trim())
    .filter(Boolean)

/**
 * Render a slash-separated category path as an "A > B > C" breadcrumb string.
 */
const toCategoryBreadcrumb = (path?: string): string =>
  splitCategoryPath(path).join(' > ')

export {
  getDepartment,
  getDepartmentOptions,
  getFamily,
  getFamiliesOptionsBySection,
  getSection,
  getSectionOptionsByDepartment,
  splitCategoryPath,
  toCategoryBreadcrumb,
}
